import WbHttpClient from './wbhttpclient';

export default class NotificationService {
  constructor() {
    this.WbHttpClient = new WbHttpClient();
  }

  getNotificationData(params = {}) {
    return this.WbHttpClient.get('notifications/getNotificationData', params);
  }

  getNotificationCount(params = {}) {
    return this.WbHttpClient.get('notifications/getNewNotificationCount', params);
  }

  deleteAllNotifications(params = {}) {
    return this.WbHttpClient.post('workboard/deleteAllRecentNotifications', params);
  }

  resetNewNotificationCount() {
    return this.WbHttpClient.get('notifications/resetNewNotificationCount');
  }
  
}